import { WorkflowConnection } from "./workflow-connection.model";

export class WorkflowConnectionWrapper {     
    $type: string;
    $values: WorkflowConnection[] = [];
    
    constructor(type: string) {
        this.$type = type;         
        this.$values = [];     
    }

}



